import _ from 'lodash'
import { PRICE_SELECTED, QUOTED } from 'pu-data/QuoteSteps';

import DefaultState from './DefaultState'

const copyParameter = [
  'part_number',
  'revision',
  'supplier_selected',
  'row_selected',
  'column_selected',
  'product_quote_number',
  'quote_config_key',
]

const state = _.assign({}, DefaultState)

if (Spree.home_assembly_parameters) {
  Object.assign(state.parameters, Spree.home_assembly_parameters);
}

if (Spree.assemblyVariants) {
  state.assemblyVariants = {
    'assembly-us': Spree.assemblyVariants.us,
    'assembly-mx': Spree.assemblyVariants.mx,
  }
}

if (Spree.items_quote) {
  const currentVariantId = _.keys(Spree.items_quote)
    .find((id) => _.values(Spree.assemblyVariants).includes(_.parseInt(id)));

  if (currentVariantId) {
    const data = Spree.items_quote[currentVariantId];
    const { supplier_selected } = Spree.items_parameters[currentVariantId];

    state.quote = data;
    state.currentVariant = state.assemblyVariants[supplier_selected];

    _.assign(
      state.parameters,
      data.line_items.find((li) => li.product_key === supplier_selected).options,
    )

    copyParameter.forEach((prm) => {
      state.parameters[prm] = Spree.items_parameters[currentVariantId][prm]
    })

    if (_.isNil(state.parameters.row_selected) || _.isNil(state.parameters.column_selected)) {
      state.showSummary = false
      state.itemSelected = false
      state.quoteStep = QUOTED
    } else {
      state.showSummary = true
      state.itemSelected = true
      state.quoteStep = PRICE_SELECTED
    }

    if (state.parameters.row_selected) {
      state.parameters.row_selected = parseInt(state.parameters.row_selected, 10)
    }

    if (state.parameters.column_selected) {
      state.parameters.column_selected = parseInt(state.parameters.column_selected, 10)
    }
  }
}

export default state
